<template>
  <div>
    <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
        <div class="page_nav">
          <ul>
            <li>
              <router-link to="/main" @click.native="$store.commit('setActive', '')">{{
                $t("common.home")
              }}</router-link>
            </li>
            <li>
              <a href="#">{{ $t("common.login") }}</a>
            </li>
          </ul>
        </div>
        <h2>{{ $t("common.welcomeGsis") }}</h2>
      </div>
    </div>
    <div class="login_bg_wrap">
      <section class="sub_contents_wrap container">
        <div class="sub_contents_wrap">
          <div class="login_wrap">
            <div class="login_box">
              <h2>{{ $t("login.LOGIN") }}</h2>
              <p class="login_int_box">
                <input
                  type="text"
                  placeholder="ID"
                  v-model="map.loginId"
                  class="login_int text"
                  title="Id"
                  v-validate="'required'"
                />
              </p>
              <p class="login_int_box pw_type">
                <input
                  type="password"
                  v-model="map.password"
                  @keyup.enter="beforeLogin()"
                  placeholder="Password"
                  class="login_int"
                  title="password"
                  v-validate="'required'"
                />
              </p>
              <div class="login_link_box">
                <p class="logout_alert_t">
                  * Session automatically terminated after 30 minutes of inactivity  
                </p>
                <router-link class="forgot_t" to="/forgot/id">{{
                  $t("login.forgotPassword")
                }}</router-link>
              </div>
              <p class="btn_login_con">
                <button
                  class="btn btn-primary btn-lg w-100"
                  @click="beforeLogin()"
                  style="font-weight: 700"
                >
                  {{ $t("login.LOGIN") }}
                </button>
              </p>
              <!--
              <p class="account_t_box">
                {{ $t("login.dontHaveAnAccount") }}
                <router-link :to="'/signup'"
                  ><span>{{ $t("login.createAccount") }}</span></router-link
                >
              </p> -->
            </div>
          </div>
        </div>
      </section>
    </div>

    <LoginTermModal v-if="showModal1" @close="showModal1 == false">
      <template slot="header">
        <h3>{{ $t("common.confidentialityNotice") }}</h3>
        <button
          type="button"
          class="btn-close popup_close_bt"
          @click="closeTermModal"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="body">
        <div v-show="this.$i18n.locale != 'Korean' && this.userDiv == 1">
          <p>
            The information contained in this site is Confidential and Proprietary. By
            entering and using Gsis and its associated web sites, You are confirming that
            you are an employee of HD HYUNDAI INFRACORE, one of their affiliates, or an authorized
            dealer.
          </p>
          <p>
            If you are not an employee, affiliate, or authorized dealer then you do not
            have permission to enter or use Gsis or its associated web sites and your
            entry or use may be in violation of applicable law.
          </p>
        </div>
        <div v-show="this.$i18n.locale == 'Korean' && this.userDiv == 1">
          <p>
            본사이트는 HD현대 인프라코어 그룹 임직원을 위한 곳이며, 사용자 접속 모니터링 및 로그를
            기록하고 있습니다.
          </p>
          <p>
            HD현대 인프라코어 임직원 이외의 사용자가 이용시에는 “부정경쟁방지 및 영업비밀보호에 대한
            법률”과 “정보통신망 이용촉진 및 정보보호 등에 관련 법률” 등 관련 법령에 의한
            민/형사상의 책임을 질 수 있습니다.
          </p>
        </div>
        <div v-show="this.$i18n.locale != 'Korean' && this.userDiv == 2">
          <p>
            This Site is for the use of authorized HD HYUNDAI INFRACORE Personnel only and by
            accessing this site you hereby consent to the site being monitored.
          </p>
          <p>
            Any unauthorized user will be considered a breach of HD HYUNDAI INFRACORE Information
            Security Policies and may also be unlawful under law.
          </p>
        </div>
        <div v-show="this.$i18n.locale == 'Korean' && this.userDiv == 2">
          <p>
            본 사이트에 포함된 정보는 기밀 및 독점 정보입니다. GSIS 및 관련 웹 사이트에
            들어가 사용하면 HD현대 인프라코어, 계열사 중 하나 또는 공인 딜러의 직원임을 확인할 수
            있습니다.
          </p>
          <p>
            직원, 제휴업체 또는 공인 대리점이 아닌 경우, 포털이나 관련 웹 사이트에
            들어가거나 사용할 수 있는 권한이 없으며, 사용자의 입장 또는 사용은 해당 법률에
            위반될 수 있습니다.
          </p>
        </div>
        <div v-show="this.$i18n.locale != 'Korean' && this.userDiv == 3">
          <p>
            This Site is for use of authorized user only and by accessing this site you
            hereby consent to site being monitored.
          </p>
          <p>
            Any unauthorized user will be considered a breach of HD HYUNDAI INFRACORE information
            security policies and may also be unlawful under law.
          </p>
        </div>
        <div v-show="this.$i18n.locale == 'Korean' && this.userDiv == 3">
          <p>
            본 사이트는 인증된 사용자만 사용할 수 있으며 본 사이트에 액세스하여
            모니터링되는 사이트에 동의합니다.
          </p>
          <p>
            권한이 없는 사용자는 HD현대 인프라코어 그룹 정보 보안 정책에 위반되는 것으로 간주되며,
            법률에 따라 불법이 될 수도 있습니다.
          </p>
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="login()"
          @keyup.enter="nextModal"
          class="btn btn-primary"
        >
          {{ $t("common.agree") }}
        </button>
        <button
          type="button"
          @click="closeTermModal()"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.disagree") }}
        </button>
      </template>
    </LoginTermModal>

    <LoginInfoModal v-if="showModal2" @close="showModal2 == false">
      <template slot="header">
        <h3>{{ $t("login.loginInfo") }}</h3>
        <button
          type="button"
          class="btn-close popup_close_bt"
          @click="closeInfoModal"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="body">
        <table class="">
          <tbody>
            <tr>
              <th>{{ $t("login.userName") }}</th>
              <td>{{ user.userName }}</td>
            </tr>
            <tr>
              <th>{{ $t("login.currentIp") }}</th>
              <td>{{ user.recentLoginIp }}</td>
            </tr>
            <tr>
              <th>{{ $t("login.lastIp") }}</th>
              <td>{{ user.lastLoginIp }}</td>
            </tr>
            <tr>
              <th>{{ $t("login.lastLoginTime") }}</th>
              <td>{{ user.lastLoginDatetime }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="closeInfoModal"
          @keyup.enter="closeInfoModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.main") }}
        </button>
      </template>
    </LoginInfoModal>
  </div>
</template>

<script>
import { login, getUserDiv } from "@/api/login";
import { getMenuList } from "@/api/menu";
// import { logout } from "@/api/login";
import LoginTermModal from "@/components/modal/LoginTermModal";
import LoginInfoModal from "@/components/modal/LoginInfoModal";

export default {
  components: {
    LoginTermModal,
    LoginInfoModal,
  },
  data() {
    return {
      infoModal: false,
      contractModal: "",
      user: {},
      userid: "",
      passwd: "",
      map: {},
      userDiv: 3,
      showModal1: false,
      showModal2: false,
    };
  },
  methods: {
    async beforeLogin() {
      const resp = await getUserDiv(this.map);
      if (resp.data.status) {
        this.userDiv = resp.data.userDiv;
      }
      this.showModal1 = true;
    },
    async login() {

      const validForm = await this.$validator.validateAll();
      if (!validForm) {
        alert(this.$t("alert.plzCheckAllValues"));
        this.showModal1 = false;
        return;
      }
      try {
        const response = await login(this.map);

        if (response.data.message != null) {
          this.showModal1 = false;
          return alert(this.$t("alert.plzCheckAllValues"));
        }
        // 비밀번호 오류 5회 이상시
        if (response.data.overPwdFailCnt) {
          alert(this.$t("login.YouGotWorongPasswordMoreFivePleaseContactManager"));
          this.map.userid = "";
          this.map.passwd = "";
          this.showModal1 = false;
          return;
        }

        if (response.data.status) {
          this.$session.set("token", "Bearer " + response.data.token);
          this.$session.set("loginUser", response.data.loginUser);
          this.$session.set("user", response.data.user);
          this.$session.set("userName", response.data.user.userName);
          this.user = response.data.user;
          this.$store.commit("setFirstLogin", true);
          this.$store.commit("setActive", "");
          this.$store.commit("setLoginUser", response.data.loginUser);
          // 메뉴가져오기
          try {
            const { data } = await getMenuList();
            // 메뉴가져왔을시
            if (data.parentMenu != null) {
              this.$session.set("parentMenu", data.parentMenu);
              this.$session.set("subMenu", data.childMenu);
              this.nextModal();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          alert(this.$t("login.TheresNoLoginInformation"));
          this.map.userid = "";
          this.map.passwd = "";
          this.showModal1 = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    nextModal() {

      this.closeTermModal();
      this.showModal2 = true;
      setTimeout(
        function () {
          this.showModal2 = false;

          if(this.$route.path != "/main"){
            this.$router.push("/main").catch( () => { } );
          }

        }.bind(this),
        2000
      );
    },
    closeTermModal() {
      this.showModal1 = false;
    },
    closeInfoModal() {

      this.showModal2 = false;
      this.$router.push("/main");
    },
    async checkLogout() {
      // if (this.$session.get("userName") != null) {
        this.$session.destroy();
        this.$store.commit("setLoginUser", "");
        // this.$session.destroy();
        // await logout();
        this.getMenu();
      // }
    },
    async getMenu() {
      try {
        const { data } = await getMenuList("logout");
        if (data.parentMenu != null) {
          this.$session.set("parentMenu", data.parentMenu);
          this.$session.set("subMenu", data.childMenu);
          this.$session.set("loginUser", null);
          this.$session.set("userName", null);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.checkLogout();
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
